// NAV SCROLL
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  }, { passive: true });
}

// PRODUCT IMAGE GALLERY
const galleryMain = document.getElementById('gallery-main');
const thumbs = document.querySelectorAll('.thumb');
if (galleryMain && thumbs.length) {
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const index = thumb.dataset.index;
      document.querySelectorAll('.gallery-slide').forEach(s => s.classList.remove('active'));
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      const target = galleryMain.querySelector(`[data-index="${index}"]`);
      if (target) target.classList.add('active');
      thumb.classList.add('active');
    });
  });
}

// ACCORDION
document.querySelectorAll('.accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const content = trigger.nextElementSibling;
    const icon = trigger.querySelector('.accordion-icon');
    const isOpen = content.classList.contains('open');
    content.classList.toggle('open', !isOpen);
    trigger.setAttribute('aria-expanded', !isOpen);
    if (icon) icon.textContent = isOpen ? '+' : '−';
  });
});

// SIZE SELECTOR + VARIANT UPDATE
const sizeButtons = document.querySelectorAll('.size-btn');
const variantInput = document.getElementById('variant-id');
const priceEl = document.getElementById('product-price');
const atcBtn = document.getElementById('atc-btn');
const stickyBtn = document.getElementById('sticky-atc-btn');

sizeButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    sizeButtons.forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    const variantId = btn.dataset.variantId;
    const price = btn.dataset.variantPrice;
    const available = btn.dataset.variantAvailable === 'true';

    if (variantInput) variantInput.value = variantId;
    if (priceEl && price) priceEl.textContent = price;

    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to bag' : 'Sold out';
    }
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.textContent = available ? 'Add to bag' : 'Sold out';
    }
  });
});

// STICKY ATC — show after main ATC scrolls out of view
const mainAtc = document.getElementById('atc-btn');
const stickyAtc = document.getElementById('sticky-atc');
if (mainAtc && stickyAtc) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      stickyAtc.style.display = e.isIntersecting ? 'none' : 'block';
    });
  }, { threshold: 0 });
  observer.observe(mainAtc);

  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      document.getElementById('product-form').dispatchEvent(new Event('submit', { bubbles: true }));
      document.getElementById('product-form').submit();
    });
  }
}

// CART QTY UPDATE
document.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', async () => {
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    const qtyEl = btn.parentElement.querySelector('.qty-num');
    let qty = parseInt(qtyEl.textContent);
    qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (res.ok) window.location.reload();
    } catch (e) {
      console.error('Cart update failed', e);
    }
  });
});

// CART REMOVE
document.querySelectorAll('.cart-item-remove').forEach(btn => {
  btn.addEventListener('click', async () => {
    const key = btn.dataset.key;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (res.ok) window.location.reload();
    } catch (e) {
      console.error('Remove failed', e);
    }
  });
});

// ADD TO CART — prevent default & show feedback
const productForm = document.getElementById('product-form');
if (productForm) {
  productForm.addEventListener('submit', async (e) => {
    const sizeSelected = document.querySelector('.size-btn.selected');
    const hasSizes = document.querySelectorAll('.size-btn').length > 0;

    if (hasSizes && !sizeSelected) {
      e.preventDefault();
      const sizeGroup = document.querySelector('.option-group');
      if (sizeGroup) {
        sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeGroup.style.outline = '1px solid var(--gold)';
        setTimeout(() => sizeGroup.style.outline = '', 2000);
      }
      return;
    }

    e.preventDefault();
    const btn = document.getElementById('atc-btn');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const formData = new FormData(productForm);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (res.ok) {
        btn.textContent = 'Added ✓';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
        // Update cart count in nav
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartLink = document.querySelector('.nav-cart');
        if (cartLink) {
          cartLink.textContent = `Bag (${cart.item_count})`;
        }
      } else {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    } catch (err) {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });
}
